goog.provide("shadow.js.shim.module$ol$Map");
goog.provide("module$shadow_js_shim_module$ol$Map");
shadow.js.shim.module$ol$Map = shadow.js.nativeProvides["ol/Map"] = shadow$bridge("ol/Map");
module$shadow_js_shim_module$ol$Map.default = shadow.js.shim.module$ol$Map;
